import { AbstractCommand } from 'src/models/command';

class UpdateTheEditorStandardFontCommand extends AbstractCommand {
	readonly name = 'IFS_Core_Command_Commands_UpdateTheEditorStandardFontCommand';

	public constructor(fontSize: string, fontSizeView: string, fontFamily: string, fontFamilyView: string) {
		super();
		this.parameters = {
			fontFamily,
			fontFamilyView,
			fontSize,
			fontSizeView,
		};
	}
}

export { UpdateTheEditorStandardFontCommand };
